import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    backgroundSize: 'cover',
    height: '100vh',
    width: '100%',
    overflow: 'hidden',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },
});
